import apiClient from './client';

export interface RegisterData {
  email: string;
  password: string;
}

export interface LoginData {
  email: string;
  password: string;
}

export const register = (data: RegisterData) =>
  apiClient.post('/auth/register', data);

export const verifyEmail = (token: string) =>
  apiClient.get(`/auth/verify/${token}`);

export const login = (data: LoginData) =>
  apiClient.post('/auth/login', data);

export const logout = () => {
  localStorage.removeItem('token');
  apiClient.post('/auth/logout');
};

export interface OAuthProvider {
  name: string;
  display_name: string;
}

export const getOAuthProviders = () =>
  apiClient.get<OAuthProvider[]>('/auth/oauth/providers');

export interface MeResponse {
  id: number;
  email: string;
  has_password: boolean;
  oauth_provider: string;
  created_at: string;
  max_points: number;
  is_admin: boolean;
}

export const getMe = () =>
  apiClient.get<MeResponse>('/user/me');

export const changePassword = (current_password: string, new_password: string) =>
  apiClient.put('/user/password', { current_password, new_password });